

document.addEventListener('DOMContentLoaded', function() {
    
    document.querySelectorAll('a[data-cart-page="true"]').forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[Cart Page Remove] Click detected:', link);

        const bundleId = link.dataset.bundleId;
        let updates = {};

        if (bundleId) {
          
          document.querySelectorAll(`a[data-bundle-id="${bundleId}"]`).forEach(l => {
            const href = l.getAttribute('href');
            const match = href.match(/id=([^&]+)&quantity=(\d+)/);
            if (match) {
              const lineKey = match[1];
              updates[lineKey] = 0; 
              console.log('[Cart Page Remove] Adding to updates:', lineKey);
            }
          });
        } else {
          
          const href = link.getAttribute('href');
          const match = href.match(/id=([^&]+)&quantity=(\d+)/);
          if (match) {
            updates[match[1]] = 0;
            console.log('[Cart Page Remove] Single item update:', match[1]);
          }
        }

        if (Object.keys(updates).length === 0) {
          console.warn('[Cart Page Remove] No items found to remove');
          return;
        }

        console.log('[Cart Page Remove] Sending POST to /cart/update.js with:', updates);

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(data => {
          console.log('[Cart Page Remove] Update result:', data);
          window.location.reload(); 
        })
        .catch(err => console.error('[Cart Page Remove] Error:', err));
      });
    });
  }, true);



// assets/custom-bundle-remove.js
(function () {
  
  document.addEventListener("DOMContentLoaded", () => {  
    const cartDrawer = document.querySelector("cart-drawer");
    cartDrawer.addEventListener("click", async (e) => {
      const removeLink = e.target.closest('a[data-bundle-id]');
      if (!removeLink) return;

      e.preventDefault();
      e.stopPropagation();

      const bundleId = removeLink.dataset.bundleId;
      console.log("[Bundle Remove] CLICK detected:", removeLink, "BundleId:", bundleId);

      console.log(location.pathname);
      const isCartPage = /(^|\/)cart(\/|$)/.test(location.pathname);
      const lineItems = isCartPage
        ? document.querySelectorAll('table.order-summary .line-item')
        : document.querySelectorAll('cart-drawer .line-item');
console.log(lineItems);
      const bundleItems = Array.from(lineItems).filter(li => {
        return li.dataset.bundleId === bundleId;
      });
console.log(bundleItems);
      if (bundleItems.length === 0) {
        console.warn("[Bundle Remove] No items found for bundleId:", bundleId);
        return;
      }

      console.log("[Bundle Remove] Keys to remove:", bundleItems);

      // Собираем line_key для AJAX
      const updates = {};
      bundleItems.forEach(item => {
        const lineKey = item.querySelector('[data-line-key]')?.dataset.lineKey;
        if (lineKey) updates[lineKey] = 0;
      });

      if (Object.keys(updates).length === 0) {
        console.warn("[Bundle Remove] No line_keys found, cannot remove bundle");
        return;
      }

      bundleItems.forEach(item => {
        const loader = item.querySelector('pill-loader');
        if (loader) {
          loader.setAttribute('aria-busy', 'true'); 
        }
      });

      try {                
        console.log("[Bundle Remove] Sending update.js payload:", updates);
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates })
        });
        const data = await response.json();
        console.log("[Bundle Remove] update result:", data);

        if(isCartPage) {
          window.location.reload();
        } else {
          const event = new CustomEvent("cart:refresh");
          document.dispatchEvent(event);
        }
      } catch (err) {
        console.error("[Bundle Remove] Failed:", err);
      }

      bundleItems.forEach(item => {
        const loader = item.querySelector('pill-loader');
        if (loader) {
          loader.setAttribute('aria-busy', 'true'); 
        }
      });
    });
  }, true);


})();


/**
 * Horizontal filter row on the collection page (see 'custom-filter-row.liquid').
 *
 * The row keeps the theme's <scroll-carousel>, which is what swipes on touch and what adds the "is-scrollable" class
 * the controls are shown by, but it does not use the theme's prev/next buttons. Those are built for media carousels:
 * they step by one fixed slide width and they only enable themselves once the scroller has travelled more than the
 * hardcoded 125px "nearing the edge" threshold. Filter values are far narrower than that, so the previous button never
 * came back on, and the first values stayed out of reach. Here the buttons page by the visible width and their state
 * comes straight from the scroll position.
 */
(function () {
  class CustomFilterRow extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.custom-filter__scroller');

      if (!this.scroller) return;

      this.controls = this.querySelectorAll('[data-filter-control]');
      this.abortController = new AbortController();

      const { signal } = this.abortController;

      this.controls.forEach((control) => {
        control.addEventListener(
          'click',
          () => this.scrollByPage(control.dataset.filterControl === 'prev' ? -1 : 1),
          { signal }
        );
      });

      this.scroller.addEventListener('scroll', () => this.updateControls(), { signal, passive: true });

      // The row only overflows once the values are laid out, and the amount it overflows by changes with the viewport.
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.scroller);

      this.updateControls();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    /**
     * In RTL the scroll position runs from 0 down to negative values, so everything below works on the distance
     * travelled from the start and this sign puts it back into the axis the scroller actually uses.
     */
    get directionSign() {
      return getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    }

    get maxScroll() {
      return Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
    }

    get scrolled() {
      return Math.abs(this.scroller.scrollLeft);
    }

    scrollByPage(direction) {
      // A whole visible width would push the value at the edge out of sight, so a page stops just short of it.
      const page = Math.max(this.scroller.clientWidth * 0.8, 1);

      this.scroller.scrollBy({ left: page * direction * this.directionSign, behavior: 'smooth' });
    }

    updateControls() {
      // Sub-pixel widths mean the scroller rarely lands exactly on either end, hence the one pixel of tolerance.
      this.controls.forEach((control) => {
        control.disabled =
          control.dataset.filterControl === 'prev' ? this.scrolled <= 1 : this.scrolled >= this.maxScroll - 1;
      });
    }
  }

  if (!window.customElements.get('custom-filter-row')) {
    window.customElements.define('custom-filter-row', CustomFilterRow);
  }
})();

